export const getEmbedUrl = (inputUrl?: string) => {
  if (!inputUrl) {
    return null;
  }

  try {
    const url = new URL(inputUrl);
    if (!url.host.endsWith('snapchat.com')) {
      return null;
    }

    // If URL already ends with /embed, return as is
    if (url.pathname.endsWith('/embed')) {
      return url.toString();
    }

    // Otherwise, add /embed to the end
    url.pathname += '/embed';
    return url.toString();
  } catch (error) {
    return null;
  }
};
